// Check if a value is falsy excluding 0's and empty strings
export const isNullish = (value: unknown): value is undefined | null => value === undefined || value === null;
